<template>
  <div class="incentive-fornew-root" :class="{ graymask: limited }">
    <div class="custom-nav-block" :style="`padding-top:${topBarHeight}px`">
      <van-nav-bar class="van-bar" left-arrow @click-left="closeWeb">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow01.webp" alt="" />
        </template>
      </van-nav-bar>
    </div>

    <div class="incentive-fornew-head" :style="{ 'margin-top': `-${topBarHeight + 46}px` }">
      <div :style="{ height: `${topBarHeight + 46}px` }"></div>
      <div class="head-con">
        <img class="img-tit" v-if="$i18n.locale === 'ar'" src="./images/head-ar.webp" />
        <img class="img-tit" v-else-if="$i18n.locale === 'es'" src="./images/head-es.webp" />
        <img class="img-tit" v-else-if="$i18n.locale === 'id'" src="./images/head-id.webp" />
        <img class="img-tit" v-else-if="$i18n.locale === 'pt'" src="./images/head-pt.webp" />
        <img class="img-tit" v-else="$i18n.locale === 'en'" src="./images/head-en.webp" />
        <div class="deal-line">
          <div class="timer">
            <img src="./images/clock.webp" />
            <span>{{ countdownObj.countdownResult.hours }}{{ $t('lang.ActCommon.k060') }}</span>
            <span>{{ countdownObj.countdownResult.minutes }}{{ $t('lang.ActCommon.k061') }}</span>
            <span>{{ countdownObj.countdownResult.seconds }}{{ $t('lang.ActCommon.k062') }}</span>
          </div>
        </div>
        <img class="img-top" :src="getMatchTitle('top-img')" />
      </div>
    </div>

    <div v-if="actInfo" class="incentive-fornew-con">
      <div class="info-tit">
        <div class="left"></div>
        <div class="center">{{ $t('lang.IncentiveForNew.k001') }}</div>
        <div class="right"></div>
      </div>

      <div v-if="actInfo.milestones" class="progress-block">
        <div class="progress-tips">{{ $t('lang.IncentiveForNew.k002') }}</div>
        <div class="progress-box">
          <!-- 左 -->
          <div>
            <template v-if="actInfo.milestones[0] && actInfo.milestones[0].rewardBeans > 0">
              <div class="box-top" @click="handleClaim1(actInfo.milestones[0])">
                <!-- prettier-ignore -->
                <div>
                  {{ actInfo.milestones[0].rewardBeans }}<img :src="getMatchImg('beans')">
                </div>
                <img src="./images/tips-arrow.webp" />
              </div>
              <img v-if="actInfo.milestones[0].ifClaimed" class="box" src="./images/box-open.webp" />
              <img
                v-else
                class="box"
                :class="{ sharking: actInfo.milestones[0].ifCanClaim }"
                src="./images/box.webp"
                @click="handleClaim1(actInfo.milestones[0])"
              />
            </template>
          </div>
          <!-- 中 -->
          <div>
            <template v-if="actInfo.milestones[1]">
              <div class="box-top" @click="handleClaim1(actInfo.milestones[1])">
                <!-- prettier-ignore -->
                <div>
                  {{ actInfo.milestones[1].rewardBeans }}<img :src="getMatchImg('beans')">
                </div>
                <img src="./images/tips-arrow.webp" />
              </div>
              <img v-if="actInfo.milestones[1].ifClaimed" class="box" src="./images/box-open.webp" />
              <img
                v-else
                class="box"
                :class="{ sharking: actInfo.milestones[1].ifCanClaim }"
                src="./images/box.webp"
                @click="handleClaim1(actInfo.milestones[1])"
              />
            </template>
          </div>
          <!-- 右 -->
          <div>
            <template v-if="actInfo.milestones[2]">
              <div class="box-top" @click="handleClaim1(actInfo.milestones[2])">
                <!-- prettier-ignore -->
                <div>
                  {{ actInfo.milestones[2].rewardBeans }}<img :src="getMatchImg('beans')">
                </div>
                <img src="./images/tips-arrow.webp" />
              </div>
              <img v-if="actInfo.milestones[2].ifClaimed" class="box" src="./images/box-open.webp" />
              <img
                v-else
                class="box"
                :class="{ sharking: actInfo.milestones[2].ifCanClaim }"
                src="./images/box.webp"
                @click="handleClaim1(actInfo.milestones[2])"
              />
            </template>
          </div>
        </div>
        <div class="progress-wraper">
          <div class="progress-bar">
            <div class="step step0" :class="{ on: actInfo.milestones[0] && actInfo.milestones[0].ifCanClaim }"></div>
            <div class="step step1" :class="{ on: actInfo.milestones[1] && actInfo.milestones[1].ifCanClaim }"></div>
            <template v-if="actInfo.ifShowOther">
              <div class="step step2"></div>
              <div class="step step3"></div>
              <div class="step step4"></div>
            </template>
            <div class="step step5" :class="{ on: actInfo.milestones[2] && actInfo.milestones[2].ifCanClaim }"></div>
            <div class="progress-trace" :style="{ width: mePosition }">
              <div v-if="actInfo.earnBeans" class="me"></div>
            </div>
          </div>
        </div>
        <div class="progress-beans">
          <!-- prettier-ignore -->
          <div>
            <template v-if="actInfo.milestones[0]">
              {{ actInfo.milestones[0].requireBeans }}<img :src="getMatchImg('beans')" />
            </template>
          </div>
          <!-- prettier-ignore -->
          <div>
            <template v-if="actInfo.milestones[1]">
              {{ actInfo.milestones[1].requireBeans }}<img :src="getMatchImg('beans')" />
            </template>
          </div>
          <!-- prettier-ignore -->
          <div>
            <template v-if="actInfo.milestones[2]">
              {{ actInfo.milestones[2].requireBeans }}<img :src="getMatchImg('beans')" />
            </template>
          </div>
        </div>
      </div>
    </div>

    <div class="incentive-fornew-con">
      <div class="info-tit">
        <div class="left"></div>
        <div class="center">{{ $t('lang.IncentiveForNew.k008') }}</div>
        <div class="right"></div>
      </div>

      <div class="task-block">
        <div v-for="(item, index) in tasks" :key="index" class="task-item" :class="{ 'task-off': !item.ifFinish || item.ifClaimed }">
          <div class="task-txt">{{ item.title }}</div>
          <div class="task-per">{{ item.proc }}/{{ item.target }}</div>
          <!-- prettier-ignore -->
          <div class="task-btn" @click="handleClaim2(item)">
            <template v-if="item.ifClaimed === false">
              +{{item.rewardBeans}}<img :src="getMatchImg('beans')"/>
            </template>
            <template>
              <img v-if="item.ifClaimed === true" src="./images/check.webp">
            </template>
          </div>
        </div>
      </div>
    </div>

    <div class="incentive-fornew-con">
      <div class="info-tit">
        <div class="left"></div>
        <div class="center">{{ $t('lang.ActCommon.k009') }}</div>
        <div class="right"></div>
      </div>

      <!-- prettier-ignore -->
      <div class="rules">
        <div>
          <MyPLabel class="dia-tips" :str="`1.${$t('lang.IncentiveForNew.k003')}`" />
        </div>

        <div>
          <MyPLabel class="dia-tips" :str="`2.${$t('lang.IncentiveForNew.k004')}`" />
        </div>

        <div>3.{{ $t('lang.IncentiveForNew.k005') }}</div>

        <div>4.{{ $t('lang.IncentiveForNew.k006') }}</div>
      </div>
    </div>

    <div style="height: 150px"></div>

    <div v-if="showReward" class="mask">
      <div class="dia-con">
        <div class="reward-item">
          <span>{{ reward }}</span>
          <img :src="getMatchImg('beans')" alt="" />
        </div>

        <p class="dia-tips">{{ $t('lang.IncentiveForNew.k013') }}</p>

        <div class="rules-btn" @click="showReward = false">{{ $t('lang.ActCommon.k100') }}</div>
      </div>
    </div>

    <div v-if="limited" class="mask">
      <div class="dia-con">
        <MyPLabel class="dia-tips" :str="$t('lang.IncentiveForNew.k007')" />
        <div class="rules-btn" @click="closeWeb">{{ $t('lang.ActCommon.k100') }}</div>
      </div>
    </div>

    <div v-if="showVerification" class="mask">
      <div class="dia-con">
        <div class="dia-tit">{{ $t('lang.IncentiveForNew.k012') }}</div>
        <p class="dia-tips">{{ $t('lang.IncentiveForNew.k009') }}</p>
        <div class="btn-block">
          <div class="rules-btn close" @click="closeWeb">{{ $t('lang.IncentiveForNew.k011') }}</div>
          <div class="rules-btn-gap"></div>
          <div class="rules-btn" @click="toVerify">{{ $t('lang.IncentiveForNew.k010') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getActBaseInfo, actRewardClaim1, actRewardClaim2 } from './apidir/api.js'

import CountDownClass from '@/utils/count-down.js'

import vavaTopImg from './images/vava/top.webp'
import echoTopImg from './images/echo/top.webp'
import joychatTopImg from './images/joychat/top.webp'
import kikoTopImg from './images/kiko/top.webp'

export default {
  data() {
    return {
      packageName: '',
      actInfo: null,
      countdownObj: null,
      tasks: [],
      mePosition: '0%',
      claim1Loading: false,
      claim2Loading: false,
      // 领取结果弹框
      showReward: false,
      reward: 0,
      // 限制弹框
      limited: false,
      // 去认证
      showVerification: false,
    }
  },
  methods: {
    getMatchTitle(imgname) {
      const imgsMap = {
        'top-img': {
          vava: vavaTopImg,
          echo: echoTopImg,
          joychat: joychatTopImg,
          kiko: kikoTopImg,
        },
      }

      // 按包名判断
      const appName = this.getAppName()
      if (this.appNameFlag('vava', appName)) {
        return imgsMap[imgname]['vava']
      }
      if (this.appNameFlag('echo', appName)) {
        return imgsMap[imgname]['echo']
      }
      if (this.appNameFlag('joychat', appName)) {
        return imgsMap[imgname]['joychat']
      }
      if (this.appNameFlag('kiko', appName)) {
        return imgsMap[imgname]['kiko']
      }
    },
    // 获取数据
    fetchData() {
      getActBaseInfo().then((resData) => {
        if (!resData.error) {
          this.actInfo = resData || null

          if (this.actInfo) {
            // 认证
            this.showVerification = this.actInfo.ifVerify === false

            if (!this.showVerification) {
              // 违规
              this.limited = this.actInfo.ifForbiddenTake

              if (this.actInfo.milestones && this.actInfo.milestones.length) {
                if (
                  this.actInfo.earnBeans > this.actInfo.milestones[0].requireBeans &&
                  this.actInfo.earnBeans < this.actInfo.milestones[1].requireBeans
                ) {
                  this.mePosition = '25%'
                }

                if (this.actInfo.earnBeans === this.actInfo.milestones[1].requireBeans) {
                  this.mePosition = '50%'
                }

                if (
                  this.actInfo.earnBeans > this.actInfo.milestones[1].requireBeans &&
                  this.actInfo.earnBeans < this.actInfo.milestones[2].requireBeans
                ) {
                  this.mePosition = '60%'
                }

                if (this.actInfo.earnBeans >= this.actInfo.milestones[2].requireBeans) {
                  this.mePosition = '100%'
                }
              }
              if (this.actInfo.taskList && this.actInfo.taskList.length) {
                this.tasks = this.actInfo.taskList
              }
              if (this.actInfo.endTimestamp) {
                if (this.countdownObj && this.countdownObj.animationFrameId) {
                  cancelAnimationFrame(this.countdownObj.animationFrameId)
                  this.countdownObj.animationFrameId = null
                }
                this.countdownObj.initCountDown(this.actInfo.endTimestamp, 'HMS', true)
              }
            }
          }
        }
      })
    },
    toVerify() {
      this.appAction('open_user_verify_page')
    },
    handleClaim1(item) {
      if (item.cfgId && item.ifCanClaim === true && item.ifClaimed === false) {
        if (this.claim1Loading) {
          return
        }
        this.claim1Loading = true

        actRewardClaim1(item.cfgId).then((resData) => {
          if (resData && resData.rewardBeans) {
            this.showReward = true
            this.reward = resData.rewardBeans

            this.fetchData()
          }
          this.claim1Loading = false
        })
      }
    },
    handleClaim2(item) {
      if (item.taskId && item.ifFinish === true && item.ifClaimed === false) {
        if (this.claim2Loading) {
          return
        }
        this.claim2Loading = true

        actRewardClaim2(item.taskId).then((resData) => {
          if (resData && resData.rewardBeans) {
            this.showReward = true
            this.reward = resData.rewardBeans

            this.fetchData()
          }
          this.claim2Loading = false
        })
      }
      //
      else {
        if (item.ifClaimed === true) {
          return
        }
        if (commandRouter && item.goUrl) {
          this.appActionPro(item.goUrl)
        }
      }
    },
  },
  created() {
    this.countdownObj = new CountDownClass()
    this.fetchData()
  },
  beforeDestroy() {
    if (this.countdownObj && this.countdownObj.animationFrameId) {
      cancelAnimationFrame(this.countdownObj.animationFrameId)
    }
  },
}
</script>

<style lang="less" scoped>
.incentive-fornew-root {
  width: 100vw;
  min-height: 100vh;
  background: #1ec5c3;

  .custom-nav-block {
    background: url(./images/top-bg.webp) left top / 100% auto no-repeat;
  }

  .incentive-fornew-head {
    width: 100%;
    height: 344px;
    background: url(./images/top-bg.webp) left top / 100% 100% no-repeat;

    .head-con {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .img-tit {
        width: 327px;
        height: 88px;
      }
      .deal-line {
        width: 100%;
        height: 24px;
        margin-top: 24px;
        display: flex;
        align-items: center;
        justify-content: center;

        .timer {
          min-width: 168px;
          display: flex;
          align-items: center;
          justify-content: center;

          border-radius: 100px;
          background: #e7fafa;
          padding: 4px 8px;
          img {
            width: 24px;
            height: 24px;
            margin: 0 3px;
          }
          span {
            color: #272727;
            text-align: center;
            font-family: 'TikTokSans-Regular';
            font-size: 16px;
            font-weight: bold;
            line-height: 20px;
            margin: 0 3px;
          }
        }
      }
      .img-top {
        width: 375px;
        height: 124px;
      }
    }
  }

  .incentive-fornew-con {
    width: 355px;
    margin: 10px auto 0;
    padding-bottom: 24px;
    border-radius: 12px;
    background: #fff;

    .info-tit {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      .left {
        width: 32px;
        height: 36px;
        background: url(./images/title-slide.webp) left top/100% 100% no-repeat;
      }
      .center {
        min-width: 114px;
        height: 36px;
        background: #fff1c2;
        display: flex;
        align-items: center;
        justify-content: center;

        color: #7b040e;
        text-align: center;
        font-family: 'TikTokSans-Regular';
        font-size: 16px;
        font-weight: bold;
        line-height: 20px;
      }
      .right {
        width: 32px;
        height: 36px;
        background: url(./images/title-slide.webp) left top/100% 100% no-repeat;
        transform: rotateY(180deg);
      }
    }

    .progress-block {
      padding: 16px 0 0;
      .progress-tips {
        width: 100%;
        padding: 0 12px;
        color: #7b040e;
        text-align: center;
        font-family: 'TikTokSans-Regular';
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 125% */
      }
      .progress-box {
        width: 285px;
        margin: 20px auto 0;
        display: flex;
        align-items: center;
        > div {
          display: flex;
          flex-direction: column;
          .box-top {
            width: fit-content;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            > div {
              padding: 0 4px;
              border-radius: 10px;
              background: #fff1c2;
              color: #ff4906;
              text-align: center;
              font-family: 'TikTokSans-Regular';
              font-size: 12px;
              img {
                width: 10px;
              }
            }
            img {
              width: 8px;
              height: 8px;
            }
          }
          .box {
            width: 34px;
          }
          .sharking {
            animation: shake 1.5s infinite linear;
            transform-origin: center bottom;
          }
          &:nth-child(1) {
            display: flex;
            align-items: center;
          }
          &:nth-child(2) {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          &:nth-child(3) {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            position: relative;
          }
        }
      }
      .progress-wraper {
        width: 256px;
        height: 20px;
        margin: 5px auto 0;
        display: flex;
        align-items: center;
        .progress-bar {
          width: 255px;
          height: 8px;
          border-radius: 100px;
          background: #fff1c2;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          position: relative;
          overflow: visible;

          .step {
            width: 14px;
            height: 14px;
            border-radius: 12px;
            border-radius: 12px;
            border: 2px solid #fff;
            background: #fff1c2;
            position: absolute;
            top: 50%;
            margin-top: -7px;
            z-index: 9;
            &.on {
              border: 2px solid #fff;
              background: #ff4906;
            }
          }
          .step0 {
            left: -7px;
          }
          .step1 {
            left: 50%;
            margin-left: -7px;
          }
          .step2 {
            left: 74%;
            margin-left: -7px;
          }
          .step3 {
            left: 81%;
            margin-left: -7px;
          }
          .step4 {
            left: 88%;
            margin-left: -7px;
          }
          .step5 {
            left: 100%;
            margin-left: -7px;
          }

          .progress-trace {
            width: 20px;
            height: 100%;
            border-radius: 100px;
            background: #ff4906;
            position: relative;
            overflow: visible;
            .me {
              position: absolute;
              top: 50%;
              right: -16px;
              z-index: 99;
              margin-top: -10px;
              width: 31px;
              height: 20px;
              background: url(./images/progress-me.webp) left top / 100% 100% no-repeat;
            }
          }
        }
      }
      .progress-beans {
        width: 306px;
        height: 20px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        > div {
          color: var(--Fonts-Font-1, #333);
          text-align: center;
          font-family: 'TikTokSans-Regular';
          font-size: 14px;
          img {
            width: 12px;
          }
          &:nth-child(1) {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            padding: 0 20px;
          }
          &:nth-child(2) {
            flex: 1;
            text-align: center;
          }
          &:nth-child(3) {
            display: flex;
            align-items: center;
            justify-content: flex-end;
          }
        }
      }
    }

    .task-block {
      width: 100%;
      padding: 24px 20px 0;
      .task-item {
        width: 315px;
        min-height: 26px;
        margin-bottom: 20px;
        &:last-child {
          margin-bottom: 0;
        }

        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        .task-txt {
          flex: 1;
          color: var(--Fonts-Font-1, #333);
          font-family: 'TikTokSans-Regular';
          font-size: 14px;
          line-height: 18px;
          margin: 4px 0;
          word-break: break-all;
        }
        .task-per {
          width: 80px;
          color: #ff4906;
          text-align: right;
          font-family: 'TikTokSans-Regular';
          font-size: 14px;
          font-style: normal;
          font-weight: bold;
          line-height: 18px;
          margin: 4px 0;
          padding: 0 15px;
          display: flex;
          align-items: center;
          justify-content: flex-end;
        }
        .task-btn {
          width: 65px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          text-align: center;
          font-family: 'TikTokSans-Regular';
          font-size: 14px;
          font-weight: bold;
          padding: 4px 6px;
          border-radius: 100px;
          background-color: #ff4906;
          img {
            width: 12px;
            margin: 0 1px;
          }
        }
      }

      .task-off {
        .task-per {
          color: #cccccc;
        }
        .task-btn {
          color: #cccccc;
          background-color: #e7e7e9;
        }
      }
    }

    .rules {
      padding: 24px 20px 0;
      > div {
        color: var(--Fonts-Font-1, #333);
        font-family: 'TikTokSans-Regular';
        font-size: 15px;
        line-height: 22px;
        margin-bottom: 12px;
        display: flex;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }

  .mask {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.7);
    overflow-y: auto;

    display: flex;
    align-items: center;
    justify-content: center;

    .dia-con {
      width: 315px;
      padding: 30px 16px;
      background: #fdfdfd;
      border-radius: 12px;

      .reward-item {
        margin-top: 24px;
        padding-bottom: 6px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          width: 24px;
          margin: 0 4px;
        }

        span {
          font-family: 'Roboto-Regular';
          font-weight: bold;
          font-size: 20px;
          color: #333333;
          line-height: 28px;
          text-align: center;
        }
      }

      .dia-tit {
        width: 100%;
        margin-bottom: 20px;
        font-size: 19px;
        color: #333333;
        line-height: 18px;
        text-align: center;
        font-weight: bold;
      }

      .dia-tips {
        width: 100%;
        font-family: 'Roboto-Regular';
        font-size: 17px;
        color: #333333;
        line-height: 18px;
        text-align: center;
        margin-bottom: 16px;
      }

      .rules-btn {
        width: 255px;
        line-height: 44px;
        margin: 16px auto 0;
        background: #1ec5c3;
        border-radius: 16px;

        font-family: 'Inter-Tight';
        font-size: 18px;
        font-weight: bold;
        color: #ffffff;
        text-align: center;
      }

      .btn-block {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .rules-btn {
          border-radius: 8px;
        }
        .close {
          background-color: transparent;
          border: 1px solid #1ec5c3;
          color: #1ec5c3;
        }
        .rules-btn-gap {
          width: 30px;
        }
      }
    }
  }
}

.graymask {
  background: #eaeaea;
  .custom-nav-block,
  .incentive-fornew-head,
  .incentive-fornew-con {
    filter: grayscale(1);
  }
}

@keyframes shake {
  0% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(-10deg);
  }
  50% {
    transform: rotate(0deg);
  }
  75% {
    transform: rotate(10deg);
  }
  100% {
    transform: rotate(0deg);
  }
}

html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  .incentive-fornew-root .incentive-fornew-con .info-tit .left {
    transform: rotateY(180deg);
  }
  .incentive-fornew-root .incentive-fornew-con .info-tit .right {
    transform: rotateY(0deg);
  }

  .incentive-fornew-root .incentive-fornew-con .progress-block .progress-wraper .progress-bar .step2 {
    left: unset;
    right: 74%;
  }
  .incentive-fornew-root .incentive-fornew-con .progress-block .progress-wraper .progress-bar .step3 {
    left: unset;
    right: 81%;
  }
  .incentive-fornew-root .incentive-fornew-con .progress-block .progress-wraper .progress-bar .step4 {
    left: unset;
    right: 88%;
  }
}
</style>
